import axios from "axios";
import { DefaultModel } from "../../datamodels/onboarding/defaultModel";

export async function sendEditCommunityApiRequest(
  passedTier: string,
  passedMP: string,
  passedCommunityName: string,
  passedCommunityId: string,
  passedUUID: string,
  passedLongDescription: string
) {
  const response = await axios.post<DefaultModel>(
    `/community/admin/update/community`,
    {
      communityName: passedCommunityName,
      communityTier: passedTier,
      communityLogo: "",
      communityWebLogo: "",
      communityBanner: "",
      marketPlace: passedMP,
      description: "",
      longDescription: passedLongDescription,
      communityUuid: passedUUID,
      communitySubDomain: "",
      communityId: passedCommunityId,
      communityBio: "",
      communityNameFlag: false,
      communityTierFlag: false,
      marketPlaceFlag: false,
      descriptionFlag: false,
      communitySubDomainFlag: false,
      communityBioFlag: false,
      communityLogoFlag: false,
      communityBannerFlag: false,
      communityWebLogoFlag: false,
      longDescriptionFlag: true,
      introVideo: "",
      introVideoFlag: false,
      showSuggested: true,
      showSuggestedFlag: false,
      chatSupportEnabled: false,
      chatSupportEnabledFlag: false,
      customDomain: "",
      customDomainFlag: false,
      introVideoThumbnail: "",
      introVideoThumbnailType: "",
      introVideoThumbnailFlag: false,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        Authorization: `${localStorage.getItem(
          "@JWTTokenType"
        )} ${localStorage.getItem("@JWTToken")}`,
        "X-API-Key": process.env.REACT_APP_X_API_KEY,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}
